module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAKCAYAAABblxXYAAAAh0lEQVQ4T7XSwQ2DMAyF4d8TwDKUDRCdgf06QiXgTBeid6OgUKWQxkBFzs5n+8nCBU8sU1Vz4AFUwBNoRGRM/UuiHuyAIkBeQJ2Cf6KqmgH9ClzsJBxFDdCEN6gH3co3K28gOvEXehBceg7APcz4g54Eo/CM/gmGsLuKt3iwBcodGVolLop6Aim+NRRL98LSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/nav_icon_pre03.png
// module id = 5uUF
// module chunks = 1